import React, { JSX } from "react";
import produce from "immer";
import { Box, Checkbox, FormControlLabel, TextField, Typography } from "@mui/material";

import useAssessmentLabel from "../../hooks/useAssessmentLabel";
import { TreatmentDoneItem } from "../../interfaces/AssessmentInterfaces";

// @ts-expect-error -css
import styles from "./Assessment.module.css";

const TreatmentDone = ({
  treatmentDone,
  onChange
}: {
  treatmentDone: Array<TreatmentDoneItem>;
  onChange: (value: Array<TreatmentDoneItem>) => void;
}): JSX.Element => {
  const assessmentLabels = useAssessmentLabel();

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.treatmentDone}
        </Typography>
      </Box>
      <Box className={styles.assessmentField}>
        {!treatmentDone?.length && <Typography>No treatment plan</Typography>}
        {treatmentDone?.map((item, index) => (
          <Box key={item.service.id} sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
            <Box sx={{ display: "flex", gap: 2 }}>
              <FormControlLabel
                label={<Typography>{item.service.name}</Typography>}
                control={
                  <Checkbox
                    checked={item.checked}
                    disabled={item.isBilled}
                    onChange={(_, checked) => {
                      const newValue = produce(treatmentDone, (draft) => {
                        draft[index].checked = checked;
                      });

                      onChange(newValue);
                    }}
                  />
                }
              />

              <TextField
                value={item.service.note}
                placeholder="Note"
                size="small"
                onChange={(e) => {
                  const newValue = produce(treatmentDone, (draft) => {
                    draft[index].service.note = e.target.value;
                  });

                  onChange(newValue);
                }}
                variant="outlined"
                sx={{ flex: 1, maxWidth: "150px", width: "100%" }}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TreatmentDone;
